import { Button } from "@musa.tech/design-system";
import { useAnalytics } from "@/hooks/useAnalytics";
import { useCloudHumansReady } from "@/hooks/useCloudHumansReady";
import { useCloudHumansUnreadCount } from "@/hooks/useCloudHumansUnreadCount";
import { openCloudHumansChat } from "@/utils/cloudHumans";

const LABEL = "Abrir chat de suporte";

const unreadLabel = (count: number) =>
  count === 1
    ? `${LABEL} (1 mensagem não lida)`
    : `${LABEL} (${count} mensagens não lidas)`;

const ChatBubbleIcon = () => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.33333}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M9.55583 10.42V10.2475C9.55583 9.6825 9.905 9.37667 10.255 9.14167C10.5967 8.91167 10.9392 8.61167 10.9392 8.05833C10.9392 7.29417 10.32 6.67583 9.55667 6.67583C8.79333 6.67583 8.17333 7.29333 8.17333 8.0575" />
    <path d="M9.555 12.3692C9.48583 12.3692 9.43 12.425 9.43083 12.4942C9.43083 12.5633 9.48667 12.6192 9.55583 12.6192C9.625 12.6192 9.68083 12.5633 9.68083 12.4942C9.68083 12.425 9.625 12.3692 9.555 12.3692" />
    <path
      strokeWidth={1.41173}
      d="M13.2192 16.0967C12.135 16.705 10.8867 17.0558 9.55583 17.0558C5.41333 17.0558 2.05583 13.6983 2.05583 9.55583C2.05583 5.41333 5.41333 2.05583 9.55583 2.05583C13.6983 2.05583 17.0558 5.41333 17.0558 9.55583C17.0558 10.8875 16.705 12.1358 16.0967 13.2192L17.0558 17.0558L13.2192 16.0967Z"
    />
  </svg>
);

export const HeaderChatButton = () => {
  const isChatReady = useCloudHumansReady();
  const unreadCount = useCloudHumansUnreadCount();
  const { trackButtonClick } = useAnalytics();

  const hasUnread = unreadCount > 0;
  const label = hasUnread ? unreadLabel(unreadCount) : LABEL;

  return (
    <Button
      type="button"
      variant="ghost"
      size="icon"
      disabled={!isChatReady}
      className="relative size-6 shrink-0 rounded-xl p-1 text-neutral-700"
      aria-label={label}
      title={isChatReady ? label : "Carregando chat de suporte…"}
      onClick={() => {
        trackButtonClick({ buttonLabel: "menu_click_chat_suporte" });
        openCloudHumansChat();
      }}
    >
      <ChatBubbleIcon />
      {hasUnread && (
        <span
          data-testid="chat-unread-dot"
          aria-hidden="true"
          className="absolute -right-0.5 -top-0.5 size-2 rounded-full bg-error-500 ring-2 ring-white"
        />
      )}
    </Button>
  );
};
